// src/index.js
import './styles/index.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import DiagnosisApp from './components/DiagnosisApp';

// Reactの読み込みを確認
if (!window.React || !window.ReactDOM) {
    console.error('React or ReactDOM not loaded');
    throw new Error('Required dependencies not loaded');
}

const initApp = () => {
    const container = document.getElementById('diagnosis-app');
    if (container) {
        try {
            const root = createRoot(container);
            root.render(
                <React.StrictMode>
                    <DiagnosisApp />
                </React.StrictMode>
            );
        } catch (error) {
            console.error('アプリケーションのマウントに失敗しました:', error);
            // Display an error message on the screen
            container.innerHTML = '<div class="error-message">アプリケーションの読み込みに失敗しました。</div>';
        }
    } else {
        console.error('マウントポイント #diagnosis-app が見つかりません');
    }
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initApp);
} else {
    initApp();
}